var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 20.9375C4.17968 20.9375 3.8444 20.7936 3.55665 20.5058C3.26888 20.2181 3.125 19.8828 3.125 19.5V4.5625C3.125 4.17968 3.26888 3.8444 3.55665 3.55665C3.8444 3.26888 4.17968 3.125 4.5625 3.125H11.9875V4.5625H4.5625V19.5H11.9875V20.9375H4.5625ZM16.6375 16.2875L15.6 15.275L18.125 12.75H9.0375V11.3125H18.075L15.55 8.7875L16.5875 7.7625L20.875 12.05L16.6375 16.2875Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit2);
export default __webpack_public_path__ + "static/media/exit2.919f9cbfe819912d8ad1ef0b9723b144.svg";
export { ForwardRef as ReactComponent };